<template>
    <div>
        <AuthLayout>
            <router-view></router-view>
        </AuthLayout>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import AuthLayout from '@/components/layouts/authLayout/AuthLayout.vue';

export default defineComponent({
    components: { AuthLayout },
});
</script>
